function classNames(...classes) {return classes.filter(Boolean).join(' ')}

const OfferOrEvent = ({isPendingOffer, changePendingStatus}) => {

    return (
      <span className="isolate inline-flex rounded-md shadow-sm">
        <button type="button" onClick={() => changePendingStatus(true)}
          className={classNames(isPendingOffer ? 'bg-purple-700 text-white' : 'bg-white text-blue-700',"relative inline-flex items-center rounded-l-full px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 cursor-pointer border-none focus:z-10")}
        >
          OFFER
        </button>
        <button type="button" onClick={() => changePendingStatus(false)}
          className={classNames(isPendingOffer ? 'bg-white text-purple-700' : 'bg-blue-700 text-white', "relative -ml-px inline-flex items-center rounded-r-full bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 cursor-pointer border-none focus:z-10")}
        >
          EVENT
        </button>
      </span>
    )
  }
export default OfferOrEvent